module.exports = ".single-column {\n  width: 60%;\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: auto;\n      grid-template-columns: auto;\n  grid-gap: 20px; }\n\n.two-columns {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 50% 50%;\n      grid-template-columns: 50% 50%;\n  grid-gap: 10px; }\n\nselect {\n  height: 30px;\n  text-align-last: left; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/new-offer/customer-profile/customer-profile.component.scss
// module id = ./src/app/content/new-offer/customer-profile/customer-profile.component.scss
// module chunks = main